<template>
  <div class="addemail">
    <div class="title">
      邮箱管理 <span>{{titlename}}邮箱地址</span>
    </div>
    <div class="main">
      <div class="addEmailInfo">{{titlename}}邮箱地址</div>
      <div class="emailContent">
        <div class="emaillist">
          <label for="emailname">
            <span>*</span>姓名
          </label>
          <el-input size="small"
                    placeholder="请输入姓名"
                    v-model="emailInfo.name"></el-input>
        </div>
        <div class="emaillist">
          <label for="emailnum">
            <span>*</span>邮箱地址
          </label>
          <el-input size="small"
                    v-model="emailInfo.email"></el-input>
        </div>
        <div class="emaillist">
          <label for="remark">备注</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="emailInfo.remarks"></el-input>
        </div>
        <div class="emailBtn">
          <button class="save"
                  @click="handleAddEmailClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addEmail, updateEmail, emailList } from 'apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'addemail',
  data () {
    return {
      emailInfo: {
        id: '',
        name: '',
        email: '',
        remarks: ''
      },
      titlename: '添加'
    }
  },
  // computed: mapState({
  //   emailInfo: state => state.email.emailInfo
  // }),
  methods: {
    getData () {
      emailList({
        id: this.emailInfo.id
      }).then(res => {
        if (res.data.code === 200) {
          this.emailInfo = res.data.data.result[0]
        }
      })
    },
    handleAddEmailClick () {
      const id = this.emailInfo.id ? this.emailInfo.id : ''
      const name = this.emailInfo.name ? this.emailInfo.name : ''
      const email = this.emailInfo.email ? this.emailInfo.email : ''
      const remarks = this.emailInfo.remarks ? this.emailInfo.remarks : ''
      if (name === '' | email === '') {
        this.$message({
          message: '请输入姓名和邮箱地址',
          type: 'warning'
        })
      } else {
        const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!regEmail.test(email)) {
          this.$message({
            message: '请输入正确的邮箱地址',
            type: 'warning'
          })
        } else {
          if (this.emailInfo.id) { // 修改邮箱
            updateEmail({ id, name, email, remarks }).then(res => {
              if (res.data.code === 200 && res.status === 200) {
                this.$router.push({ path: '/manage/email' })
              }
            })
          } else { // 添加邮箱
            addEmail({ name, email, remarks }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/manage/email' })
              }
            })
          }
        }
      }
    },
    handleCancelClick () { // 取消添加/修改
      this.$router.push({ path: '/manage/email' })
    }
  },
  mounted () {
    this.emailInfo.id = this.$route.query.item
    if (this.emailInfo.id) {
      this.getData()
      this.titlename = '修改'
    }
  }
}
</script>
<style lang="stylus">
.addemail
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addEmailInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../assets/images/03/add_icon.png') no-repeat center left 15px
    .emailContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .emaillist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
      .emailBtn
        margin-left 153px
        margin-top 94px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
